import { Axios } from "../../Services/Axios";

export const fetchCustomers = async (url = undefined, params = undefined) => {
  return await Axios.get(url || `/admin/customers/list${params || ""}`, {
    responseType: "json",
  });
};
export const fetchCustomerDetails = async (id) => {
  return await Axios.get(`/admin/customers/${id}`, {
    responseType: "json",
  });
};
export const customerRegister = async (payload) => {
  return await Axios.post("/admin/customers/register", {_method: 'GET', ...payload}, {
    responseType: "json",
  });
};
